// src/components/leadsComponents/LeadListPanel.js
import React from 'react';
import LeadRow from './LeadRow';

export default function LeadListPanel({ leads, loading, onSelectLead }) {
  if (loading) {
    return <p className="text-[#6B7280] p-4">Loading leads...</p>;
  }

  return (
    <div className="flex-1 overflow-y-auto space-y-2">
      {leads.map(lead => (
        <LeadRow
          key={lead._id}
          lead={lead}
          onClick={() => onSelectLead(lead._id)}
        />
      ))}
    </div>
  );
}
